import { Button, Modal } from "react-bootstrap";

const ShowJsonDetailModal = ({
    showJsonDetailModal,
    json,
    handleCloseModal
}) => {

    const {
        id = null,
        description = '',
        conditions = [],
        then = [],
        priority = 0,
        metadata = {}
    } = json;

    const parsedConditions = typeof conditions === 'string' ? JSON.parse(conditions) : conditions;
    const parsedThen = typeof then === 'string' ? JSON.parse(then) : then;

    const actionType = parsedThen?.allows ? 'allows' : parsedThen?.block ? 'block' : null;
    const actionData = parsedThen?.[actionType] || {};

    return (
        <>
            <Modal
                show={showJsonDetailModal}
                onHide={handleCloseModal}
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Detalle de la regla</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="p-2 bg-white rounded shadow-md w-full max-w-xl">
                        <div>
                            <h2 className="text-xl font-bold text-gray-700">Regla numero: {id}</h2>
                            <div className="text-gray-600">
                                <strong>Descripción:</strong> {description}
                            </div>
                        </div>

                        <div className="mt-3">
                            <h3 className="text-md font-semibold text-gray-700">Condiciones</h3>
                            <div className="flex flex-wrap">
                                {Object.entries(parsedConditions).map(([key, values]) => (
                                    Array.isArray(values) ? (
                                        <span
                                            key={`${key}-${values.join('-')}`}
                                            className="pr-2 bg-blue-100 text-blue-800 rounded-full text-sm mb-1 mr-1"
                                        >
                                            {key}: {values.join(', ')};
                                        </span>
                                    ) : (
                                        <span
                                            key={`${key}-${values}`}
                                            className="pr-2 bg-blue-100 text-blue-800 rounded-full text-sm mb-1 mr-1"
                                        >
                                            {key}: {values};
                                        </span>
                                    )
                                ))}
                            </div>
                        </div>

                        {actionType && (
                            <div className="mt-3">
                                <h3 className="text-md font-semibold text-gray-700">
                                    {actionType === 'allows' ? 'Entonces permite' : 'Entonces bloquea'}
                                </h3>
                                <div className="flex flex-wrap">
                                    {Object.entries(actionData).map(([key, values]) =>
                                        values.map((val, idx) => (
                                            <span
                                                key={`${actionType}-${key}-${idx}`}
                                                className={`pr-3 ${actionType === 'allows' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                                                    } rounded-full text-sm`}
                                            >
                                                {key}: {val};
                                            </span>
                                        ))
                                    )}
                                </div>
                            </div>
                        )}

                        <div className="text-sm text-gray-500 mt-4">
                            <p><strong>Prioridad:</strong> {priority ?? 'null'}</p>
                            <p><strong>Metadata:</strong> {metadata && Object.keys(metadata).length > 0 ? JSON.stringify(metadata) : 'null'}</p>
                        </div>
                    </div>


                </Modal.Body>

                <Modal.Footer>
                    <Button variant="danger" onClick={handleCloseModal}>Cerrar</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ShowJsonDetailModal;